<template>
    <div class="relative flex flex-col h-full">
        <div class="pb-10 mb-12 border-b border-gray-200">
            <h2 class="pb-1 text-2xl font-bold text-left text-black no-underline normal-case non-italic">Customer Agreement</h2>
            <p class="text-lg font-normal text-left no-underline normal-case non-italic">Please review all documents before subscribing to Mammoth Research LLC.</p>
        </div>

        <app-errors :form="form" class="mb-10"></app-errors>

        <div class="flex-1 agreement-area">
            <div class="h-full max-h-full">
                <div class="space-y-8 text-base font-medium prose text-gray-600 max-w-none">
                    <p>Thank you for your subscription in <strong>Mammoth Research, LLC</strong>. Due to securities regulations, we are required to verify your accredited investor status. Please upload any of the following documents to complete the verification:</p>

                    <ul class="space-y-6">
                        <li>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quae eligendi id minus doloribus nisi, voluptatibus fuga vero magnam neque soluta sapiente quaerat ex aliquid, necessitatibus earum. Sapiente architecto perspiciatis ad!</li>
                        <li>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Odit commodi cumque inventore eius quas voluptatum, nisi, numquam porro blanditiis, dicta assumenda possimus magnam sapiente exercitationem quasi error quam temporibus ipsa?</li>
                        <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. At hic amet earum autem deserunt laborum, veritatis iure voluptate ad quam fugit labore minima dolores? Aut autem ipsum necessitatibus in voluptate.</li>
                        <li>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ab dicta sint nisi distinctio necessitatibus quis excepturi suscipit temporibus, libero maiores ipsum quaerat ad ratione debitis asperiores, accusamus dolorum molestias quas.</li>
                        <li>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Odio ratione ut dolores, nisi deleniti vel ex tempora at non veritatis officiis cum atque et numquam labore quos. Aspernatur, maiores perferendis?</li>
                        <li>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Praesentium provident sed omnis officiis labore deleniti possimus iure, ex voluptate iusto repudiandae molestias cumque nobis doloremque illum, culpa minus libero beatae?</li>
                        <li>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Praesentium provident sed omnis officiis labore deleniti possimus iure, ex voluptate iusto repudiandae molestias cumque nobis doloremque illum, culpa minus libero beatae?</li>
                        <li>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Praesentium provident sed omnis officiis labore deleniti possimus iure, ex voluptate iusto repudiandae molestias cumque nobis doloremque illum, culpa minus libero beatae?</li>
                        <li>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Praesentium provident sed omnis officiis labore deleniti possimus iure, ex voluptate iusto repudiandae molestias cumque nobis doloremque illum, culpa minus libero beatae?</li>
                        <li>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Praesentium provident sed omnis officiis labore deleniti possimus iure, ex voluptate iusto repudiandae molestias cumque nobis doloremque illum, culpa minus libero beatae?</li>
                    </ul>

                    <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus, vel ipsum officiis eius minima incidunt impedit nesciunt tempora totam placeat sequi saepe repellendus, dolorum nobis. Nostrum beatae necessitatibus quos magni. Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium ea est velit impedit, iste laboriosam dolor, aliquid expedita voluptates reprehenderit quia non, suscipit commodi. Labore deserunt officia laudantium nostrum porro.</p>
                </div>
            </div>
        </div>

        <div class="mb-16 mt-9">
            <checkbox-field v-model="form.isAgree"><span class="block -mt-1 text-lg">Check here to indicate that you have read and agree to the terms of the <strong>Mammoth Research LLC</strong></span></checkbox-field>
        </div>

        <div class="mt-6 sm:flex sm:justify-end">
            <div class="inline-flex items-center space-x-3">
                <app-button @click="handleBack" class="!border-gray-200 !bg-white !text-gray-400">Back</app-button>

                <app-button @click="handleNext" :busy="isBusy">Save and Continue</app-button>
            </div>
        </div>
    </div>
</template>

<script>
import AppButton from '@Components/Button'
import AppErrors from '@Components/Errors'
import CheckboxField from '@Fields/Checkbox'
import useForm from '@/form'
import { useStore } from 'vuex'
import { ref } from 'vue'

export default {
    components: {
        AppButton,
        AppErrors,
        CheckboxField
    },
    props: ['series'],
    emits: ['prev', 'next', 'process', 'complete', 'goto'],
    setup(props, { emit }){
        const store = useStore()

        const form = useForm(_.assign({
            isAgree: false
        }, store.state.agreementForm));

        const isBusy = ref(false)

        function handleBack(){
            emit('prev', true)
        }

        function handleNext(){
            form.errors.clear()

            if (!form.isAgree) {
                form.errors.set('agree', 'Must agree with terms and conditions')
            }

            if (form.errors.any()) {
                window.scroll(0,0)
            } else {
                isBusy.value = true

                setTimeout(() => {
                    store.commit('UPDATE_FORM_DATA', {
                        form: 'agreementForm',
                        data: form.data()
                    });

                    isBusy.value = false
                    emit('next', 3)
                }, 1000)
            }
        }

        return {
            isBusy,
            form,
            handleBack,
            handleNext
        }
    }
}
</script>

<style scoped>
.agreement-area {
    padding-right: 24px;
    overflow-y: auto;
}
.agreement-area::-webkit-scrollbar {
    width: 10px;
}
.agreement-area::-webkit-scrollbar-track {
    background: #f1f1f1;
}
.agreement-area::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 6px;
}
.agreement-area::-webkit-scrollbar-thumb:hover {
    background: #555;
}
.prose ul {
    margin-left: 20px;
}
.prose ul > li::before {
    background-color: #00f4c8;
}
</style>
